import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.77004 43.63C4.77004 43.63 8.73004 45.28 8.40004 47.59C8.07004 49.9 10.22 50.23 10.71 50.23C11.2 50.23 12.53 52.21 11.87 52.87C11.87 52.87 13.52 50.72 13.19 48.74C12.86 46.76 14.02 46.1 14.02 46.1C14.02 46.1 13.19 49.57 15.34 50.39C17.49 51.22 18.97 52.87 18.48 53.86C18.48 53.86 21.29 53.53 21.62 52.37C21.62 52.37 21.95 55.8399 23.27 56.6599C24.59 57.4899 26.74 55.1699 26.9 56.6599C26.9 56.6599 29.21 58.31 31.03 56.83C31.03 56.83 32.85 59.64 35.16 58.98C37.47 58.32 37.8 57.33 37.8 57.33C37.8 57.33 39.29 59.3099 42.26 58.6499C45.23 57.9899 45.23 56.1699 45.23 56.1699C45.23 56.1699 47.05 57.66 49.03 56.34C51.01 55.02 51.01 52.8699 52.17 54.0299C53.33 55.1899 52 55.85 52 55.85C52 55.85 56.46 55.5199 54.81 52.0499C54.81 52.0499 57.12 53.87 59.76 52.88C62.4 51.89 60.09 50.5699 61.58 50.0699C63.07 49.5699 63.4 50.8999 63.4 50.8999C63.4 50.8999 67.36 49.58 67.69 48.26C67.69 48.26 68.35 52.22 71.16 45.62C73.97 39.01 74.13 24.8099 74.13 24.8099L68.19 1.68994L6.26003 3.17993L1.64003 32.24C1.64003 32.24 -1.00996 38.84 4.77004 43.63Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
